import { apiClient } from "./base.service";
import { getAuth } from "firebase/auth";
import type {
  CreateTeamMemberData,
  TeamMember,
  UpdateTeamMemberData,
} from "@/types/startup.types";

export class TeamAPIService {
  private async getAuthHeaders() {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }
    const token = await user.getIdToken();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  async listTeamMembers(startupId: string): Promise<TeamMember[]> {
    const headers = await this.getAuthHeaders();
    return apiClient.get(`/startups/${startupId}/team-members`, { headers });
  }

  async createTeamMember(
    startupId: string,
    data: CreateTeamMemberData,
  ): Promise<TeamMember> {
    const headers = await this.getAuthHeaders();
    return apiClient.post(`/startups/${startupId}/team-members`, data, { headers });
  }

  async updateTeamMember(
    startupId: string,
    memberId: string,
    data: UpdateTeamMemberData,
  ): Promise<TeamMember> {
    const headers = await this.getAuthHeaders();
    return apiClient.put(
      `/startups/${startupId}/team-members/${memberId}`,
      data,
      { headers },
    );
  }

  async deleteTeamMember(
    startupId: string,
    memberId: string,
  ): Promise<{ success: boolean }> {
    const headers = await this.getAuthHeaders();
    return apiClient.delete(`/startups/${startupId}/team-members/${memberId}`, {
      headers,
    });
  }
}

export const teamAPI = new TeamAPIService();
